import { type Form } from '@wix/ambassador-forms-v4-form/types';

export const getCurrentStep = (form: Form, fieldId: string) => {
  const stepCount = form?.steps ? form.steps.length - 1 : 0;
  const hasSteps = stepCount > 0;
  const stepNumber =
    hasSteps &&
    form?.steps?.findIndex((step) =>
      step.layout?.large?.items?.find((item) => item.fieldId === fieldId),
    );
  const isLastStep = stepNumber === stepCount;

  return { hasSteps, stepNumber, isLastStep };
};
